<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  let step = 0;
  const steps = [
    {
      icon: '🏏',
      title: 'Score like a pro',
      text: 'Ball-by-ball scoring with auto strike rotation, extras, wickets aur live run-rate — sab automatic. "NEW MATCH" dabao aur shuru!'
    },
    {
      icon: '🎥',
      title: 'Record with TV-style overlay',
      text: 'Match ki video record karo — live score, batsman aur bowler stats video ke UPAR burn ho jaate hain, bilkul TV broadcast jaise. 4, 6 aur wicket par full animations!'
    },
    {
      icon: '📱',
      title: 'Dual-Phone Magic',
      text: 'Ek phone camera banega, doosre se scoring karo. Scorer phone par jo bhi ball dabaoge, recorder phone ki video par turant update dikhega. "Join Recorder" se try karo.'
    },
    {
      icon: '📺',
      title: 'Share LIVE score link',
      text: 'Backup tab se "Share Live Link" bhejo — koi bhi bina app install kiye browser me live score dekh sakta hai. Match khatam hone par poster aur full scorecard bhi share karo!'
    }
  ];

  function next() {
    if (step < steps.length - 1) step += 1;
    else finish();
  }
  function finish() {
    try { localStorage.setItem('cs_onboarded_v1', '1'); } catch (_) {}
    dispatch('close');
  }
</script>

<div class="tour-backdrop">
  <div class="tour-card">
    <div class="tour-icon">{steps[step].icon}</div>
    <div class="tour-title">{steps[step].title}</div>
    <div class="tour-text">{steps[step].text}</div>

    <div class="tour-dots">
      {#each steps as _, i (i)}
        <span class="dot" class:active={i === step}></span>
      {/each}
    </div>

    <button class="tour-next" on:click={next}>
      {step < steps.length - 1 ? 'NEXT →' : "LET'S PLAY 🏏"}
    </button>
    {#if step < steps.length - 1}
      <button class="tour-skip" on:click={finish}>Skip tour</button>
    {/if}
  </div>
</div>

<style>
  .tour-backdrop {
    position: fixed; inset: 0; z-index: 11000;
    display: grid; place-items: center; padding: 24px;
    background: rgba(2, 6, 23, 0.88);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
  }
  .tour-card {
    width: min(380px, 100%);
    background: linear-gradient(160deg, #101c33, #070c16);
    border: 1px solid #24334d;
    border-radius: 20px;
    padding: 32px 24px 24px;
    text-align: center;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.6);
    animation: pop-in 0.25s ease-out;
  }
  @keyframes pop-in {
    from { transform: scale(0.92); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
  }
  .tour-icon { font-size: 56px; margin-bottom: 14px; }
  .tour-title { font-size: 20px; font-weight: 900; color: #fff; margin-bottom: 10px; }
  .tour-text { font-size: 13px; color: #94a3b8; line-height: 1.65; min-height: 86px; }
  .tour-dots { display: flex; justify-content: center; gap: 7px; margin: 18px 0; }
  .dot { width: 8px; height: 8px; border-radius: 50%; background: #24334d; transition: all 0.2s; }
  .dot.active { background: #34d399; width: 22px; border-radius: 5px; }
  .tour-next {
    width: 100%; min-height: 48px; border: none; border-radius: 12px;
    background: linear-gradient(135deg, #34d399, #10b981);
    color: #052e16; font-size: 15px; font-weight: 900; letter-spacing: 0.5px;
  }
  .tour-next:active { transform: scale(0.98); }
  .tour-skip {
    margin-top: 10px; background: none; border: none;
    color: #64748b; font-size: 12px; font-weight: 700; text-decoration: underline;
    min-height: 36px;
  }
</style>
